import React, { useState} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signUp, confirmSignUp, resendSignUpCode } from 'aws-amplify/auth';
import PasswordStrengthIndicator from '../../components/passwordStrengthIndicator';
import { useSnackbar } from 'notistack';
import Preloader from '../../components/Preloader/Preloader';
import {Helmet} from 'react-helmet-async';
import {phoneCode} from '../../ProData';
import axios from 'axios';

const isNumberRegx = /\d/;
const specialCharacterRegx = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
const capsRegx=/[A-Z ]+/;
const config = require('../../config.json');

export default function SignUp() {
    const { enqueueSnackbar } = useSnackbar();
    const [username, setUsername] = useState('');
    const [userfullname, setUserfullname] = useState('');
    const [phoneno, setPhoneno]= useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [code, setCode] = useState('');
    const [countryCode, setCountryCode]=useState('+91');
    const navigate=useNavigate();
    const [showValidation, setShowValidation] = useState(false);
    const [otp, setOTP]=useState('');
    const [loaded, setLoaded] = useState(true);
    const [passwordValidity, setPasswordValidity] = useState({
        minChar: null,
        number: null,
        specialChar: null,
        capsChar:null
      });
      const [passwordFocused, setPasswordFocused] = useState(false);

  /*useEffect(() => {
    if(!loggedUser.isAuthenticated && !loginValidated){
      setLoginValidated(true);
      validateLogin();
    }
  }, [])*/
  
const handleSignUp =async(event)=>{
    event.preventDefault();
    try{
        setLoaded(false);
         if ( username==="" || password==="" || email==="" || phoneno === "" || userfullname ==="" || code === ""){
            enqueueSnackbar("Fill all the required details for Sign Up",{variant : 'info'});
         }else{
           const library_source = code;
           const res = await axios.get(`${config.api.invokeUrl}/users/validation?fetchKey=${library_source}`,{
            headers: {
              'x-api-key':config.api.key
            }
          });
          //console.log("REs :", res);
           if (res.data.length < 1){
               enqueueSnackbar("Invalid Library code. Please contact your Admin",{variant : 'info'});
            }else{
              const str = userfullname;
              const arr = str.split(" ");
              //loop through each element of the array and capitalize the first letter.
              for (var i = 0; i < arr.length; i++) {
                  arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
              }
              //Join all the elements of the array back into a string 
              //using a blankspace as a separator 
              const usernameInput = arr.join(" ");
              const lib_source=res.data[0].lib_key;
              const phone=countryCode.toString()+phoneno.toString();
              //console.log(username,email, password, lib_source, phone, usernameInput, countryCode);
              await signUp({
                username:username,
                password:password,
                options:{
                userAttributes:{
                  email:email,
                  family_name:lib_source,
                  phone_number:phone,
                  name: usernameInput,
                  given_name:"Student",
                  preferred_username:"NA",
                  profile:"Student",
                  picture:countryCode.toString(),
                }
            }
              }).then((res)=>{
                //console.log("Res :", res);
                if(!res.isSignUpComplete && res.nextStep.signUpStep==="CONFIRM_SIGN_UP"){
                    enqueueSnackbar("Account created successfully. Check your email to confirm.",{variant : 'success'});
                    setPasswordFocused(false);
                    setShowValidation(true);
                     setLoaded(true);
                }

              }).catch((err)=>{
                    const errmsg = "Error Occured : " + err.message;
                    enqueueSnackbar(errmsg,{variant : 'warning'});
                    setLoaded(true); 
                    //console.log("err :", err);         
              });
    }
        }
        setLoaded(true);
    }catch(err){
      setLoaded(true);
      enqueueSnackbar("Error Occured - " + err.message,{variant : 'warning'});
    }
}

const handleOTPValidation=async(event)=>{
    event.preventDefault();
    try{
                setLoaded(false);
        await confirmSignUp({
            username: username,
            confirmationCode: otp,
        }).then((res)=>{
            console.log("res1:", res);
            if(res.isSignUpComplete && res.nextStep.signUpStep==="DONE"){
                 enqueueSnackbar("Email Validated successfully!",{variant : 'success'});
                setUsername('');
                setEmail('');
                setPassword('');
                setUserfullname('');
                setPhoneno('');
                setCode('');
                navigate("/login");
            }
            setLoaded(true);
        }).catch((err)=>{
             setLoaded(true);
      enqueueSnackbar("Error Occured - " + err.message,{variant : 'warning'}); 
        })
    }catch(err){
             setLoaded(true);
      enqueueSnackbar("Error Occured - " + err.message,{variant : 'warning'}); 
    }
}

const handleGenerateOTP=async(event)=>{
    event.preventDefault();
    try{
        setLoaded(false);
        await resendSignUpCode({ username: username })
        .then((res)=>{
        enqueueSnackbar("OTP re-sent successfully!",{variant : 'success'});
        setLoaded(true);

        })
        .catch((err)=>{
            setLoaded(true);
            enqueueSnackbar("Error Occured - " + err.message,{variant : 'warning'});  
        })

    }catch(err){
        setLoaded(true);
      enqueueSnackbar("Error Occured - " + err.message,{variant : 'warning'});  
    }
}
  
  const onChangePassword = password => {
    setPassword(password);
    setPasswordValidity({
        minChar: password.length >= 8 ? true : false,
        number: isNumberRegx.test(password) ? true : false,
        specialChar: specialCharacterRegx.test(password) ? true : false,
        capsChar:capsRegx.test(password)?true:false
    });
  };
  
  
  return (
    <div className='p-3'>
    <Helmet>
      <title>Sign Up - Inigo Library - Arul Kadal - Chennai</title>
      <meta name="description" content="Sign Up - Inigo Library - Arul Kadal - Chennai" />
      <meta name="keywords" content="Sign Up - Inigo Library - Arul Kadal - Chennai" /> 
    </Helmet>

        {!loaded &&  <Preloader show={loaded ? false : true} /> }
        <div className='container card justify-content-center' style={{borderRadius:"30px"}}>
         <div className="text-center p-3">
          <div className='text-center'>
          <h1>Sign Up</h1>
          </div>
                    <div className="contact-form text-center m-3" >
                          <div className="row d-flex justify-content-center p-2">
                            <div className="col-lg-3 col-md-12 col-sm-12">
                                <label>Login ID</label>
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12">
                                <input name="email" type="email" className="form-control" id="email" placeholder="Preferred Login ID" required 
                                onChange={event=>setUsername(event.target.value)} value={username}/> 
                            </div>
                            </div>
                           {!showValidation? <div className="row d-flex justify-content-center p-2">
                                <div className="col-lg-3 col-md-12 col-sm-12">
                                <label>Password</label>
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12">
                                <input name="password" type="password" className="form-control" id="password" placeholder="Set up Password" required 
                    onFocus={() => setPasswordFocused(true)}
                    onChange={e =>
                        onChangePassword(e.target.value)}            
                                value={password}/>
                              </div>
                              </div>:null}
                              {!showValidation? <div className="row d-flex justify-content-center p-2">
                              <div className="col-lg-3 col-md-12 col-sm-12">
                              <label>User Name</label>
                              </div>
                                <div className="col-lg-6 col-md-12 col-sm-12">
                                <input name="username" type="text" className="form-control" id="username" placeholder="Enter Your Name" required 
                                  onChange={e =>
                                      setUserfullname(e.target.value)}            
                                value={userfullname}/>
                            </div>
                            </div>:null}
                             <div className="row d-flex justify-content-center p-2">
                              <div className="col-lg-3 col-md-12 col-sm-12">
                              <label>Email</label>
                              </div>
                                <div className="col-lg-6 col-md-12 col-sm-12">
                                <input name="email" type="email" className="form-control" id="email" placeholder="Enter Email address" required 
                                  onChange={e =>
                                      setEmail(e.target.value)}            
                                value={email}/>
                            </div>
                            </div>
                            {!showValidation?  <div className="row d-flex justify-content-center p-2">
                              <div className="col-lg-3  col-md-12 col-sm-12">
                              <label>Phone Number</label>
                              </div>
                            <div className="col-lg-1 col-md-12 col-sm-12">
                              <select className="form-control" value={countryCode} onChange={(event)=>{setCountryCode(event.target.value)}}>
                                {phoneCode.map(item => {
                                    return (<option key={item.Country} value={item.Code}>{item.Code}</option>);
                                })}
                                </select>
                            </div>
                            <div className="col-lg-5 col-md-12 col-sm-12">
                                <input name="phoneno" type="number" className="form-control" id="phoneno" placeholder="Phone Number" required 
                                  onChange={e =>
                                      setPhoneno(e.target.value)}            
                                value={phoneno}/>
                            </div>
                            </div>:null}
                            {!showValidation?  <div className="row d-flex justify-content-center p-2">
                              <div className="col-lg-3 col-md-12 col-sm-12">
                              <label>Library Code</label>
                              </div>
                                <div className="col-lg-6 col-md-12 col-sm-12">
                                <input name="librraycode" type="text" className="form-control" id="librarycode" placeholder="Enter Library Code" required 
                                  onChange={e =>
                                      setCode(e.target.value)}            
                                value={code}/>
                            </div>
                            </div>:null}
                            {showValidation? <div className="row d-flex justify-content-center p-2">
                              <div className="col-lg-3 col-md-12 col-sm-12">
                              <label> OTP to Confirm</label>
                              </div>
                                <div className="col-lg-6 col-md-12 col-sm-12">
                                <input name="otp" type="text" className="form-control" id="otp" placeholder="Enter OTP from your email" required 
                                  onChange={e =>
                                      setOTP(e.target.value)}            
                                value={otp}/>
                            </div>
                            </div>:null}
                            
                            {passwordFocused && (
                                    <PasswordStrengthIndicator
                                        validity={passwordValidity}
                                    />
                                )}
                            <div className="row d-flex justify-content-center ">
                            {!showValidation?<div style={{ textAlign: "right"}}>
                              <Link to="/login"> Sign In</Link>
                            </div>:<div style={{ textAlign: "right"}}>
                              <Link to="#" onClick={event=>handleGenerateOTP(event)}> Resend OTP</Link>
                            </div>}
                           {!showValidation?  <div className="col-lg-12  text-center">
                              <a>
                                <button type="submit" className="btn-box mt-3" onClick={event=>handleSignUp(event)}>Sign Up</button>
                              </a>
                            </div>:<div className="col-lg-12  text-center">
                              <a>
                                <button type="submit" className="btn-box mt-3" onClick={event=>handleOTPValidation(event)}>Confirm</button>
                              </a>
                            </div>}
                          </div>
                    </div>
                </div>
            </div>
</div>
  )
}
